import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisUploadFile } from '../../model/his-upload-file';
import { HisFileUploadService } from '../../service/his-file-upload.service';

@Component( {
    selector: 'his-upload-file-image',
    templateUrl: './his-upload-file-image.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisUploadFileImageComponent {
    private fileUploadService = inject(HisFileUploadService);

    value = input.required<HisUploadFile>();
    style = input<string>();
    title = input<string>();

    protected imageTitle = computed( () => {
        if ( this.title() ) {
            return this.title();
        }

        return this.value().name;
    } );

    protected imageUrl = computed( () => {
        return this.value().downloadUrl ?? this.fileUploadService.getDownloadUrl( this.value() );
    } );

}
